import { styled } from "@mui/system";
import { Dialog } from "@mui/material";
import ContainedButton from "src/components/common/ContainedButton";

export const DialogWrapper = styled(Dialog)(() => ({
  display: "flex",
  width: "100%",
  flexDirection: "column",
  alignItems: "center",
  borderRadius: "10px",
  background: "#FFF",
}));

export const Wrapper = styled("div")(({ theme }) => ({
  display: "flex",
  width: "583px",
  height: "150px",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "24px",

  [theme.breakpoints.down("sm")]: {
    width: "100%",
    height: "100%",
    padding: "16px",
  },
}));

export const ContentWrapper = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  alignSelf: "stretch",
  borderRadius: "4px",
  background: "#FFF",
  width: "100%",
}));

export const ButtonsWrapper = styled("div")(() => ({
  display: "flex",
  alignItems: "flex-end",
  gap: "12px",
  alignSelf: "stretch",
}));

interface TextProps {
  color?: string;
  weight?: number;
}
export const Text = styled("div")<TextProps>(({ color, weight }) => ({
  color: color ?? "#002035",
  fontFamily: "Roobert",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: weight ?? 400,
  lineHeight: "16px",
  textAlign: "center",
}));

interface TradeLockedUserModalProps {
  open: boolean;
  onClose: () => void;
}

const TradeLockedUserModal = (props: TradeLockedUserModalProps) => {
  const { open, onClose } = props;
  return (
    <DialogWrapper open={open} onClose={onClose} sx={{ background: "rgba(0, 32, 53, 0.7)" }}>
      <Wrapper>
        <ContentWrapper>
          <Text color="#FC4C4C" weight={600}>
            Hmmm something went wrong placing your order. Please contact your Broker to enter this
            trade.
          </Text>
        </ContentWrapper>
        <ButtonsWrapper>
          <ContainedButton
            color="neutral"
            borderRadius="4px"
            height="32px"
            onClick={onClose}
            sx={{ background: "#F8F9F9" }}>
            <Text>Close</Text>
          </ContainedButton>
        </ButtonsWrapper>
      </Wrapper>
    </DialogWrapper>
  );
};

export default TradeLockedUserModal;
